module.exports = __webpack_public_path__ + "static/media/rockporch-logo.7bb28abc.svg";